/* ALME theme behaviour. Plain JavaScript, no dependencies.
   Every feature hooks onto data-alme-* attributes in the section markup. */
(function () {
  "use strict";

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------------------------------------------------------- header + drawer */
  function initHeader() {
    var header = $("[data-alme-header]");
    if (!header) return;
    var onScroll = function () { header.classList.toggle("HeaderHero_siteHeaderScrolled", window.scrollY > 24); };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    var layer = $("[data-alme-drawer-layer]");
    var drawer = $("[data-alme-drawer]");
    var trigger = $("[data-alme-drawer-open]");
    if (!layer || !drawer || !trigger) return;
    var closeBtn = $(".HeaderHero_drawerClose", drawer);
    var previousOverflow = "";

    function focusables() {
      return $$('a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])', drawer).filter(function (el) { return el.offsetParent !== null; });
    }
    function onKey(e) {
      if (e.key === "Escape") { e.preventDefault(); close(); return; }
      if (e.key !== "Tab") return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function open() {
      layer.classList.add("HeaderHero_drawerLayerOpen");
      layer.setAttribute("aria-hidden", "false");
      trigger.setAttribute("aria-expanded", "true");
      $(".HeaderHero_drawerBackdrop", layer).tabIndex = 0;
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      if (closeBtn) closeBtn.focus();
      window.addEventListener("keydown", onKey);
    }
    function close() {
      if (!layer.classList.contains("HeaderHero_drawerLayerOpen")) return;
      layer.classList.remove("HeaderHero_drawerLayerOpen");
      layer.setAttribute("aria-hidden", "true");
      trigger.setAttribute("aria-expanded", "false");
      $(".HeaderHero_drawerBackdrop", layer).tabIndex = -1;
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKey);
      trigger.focus();
    }
    trigger.addEventListener("click", open);
    $$("[data-alme-drawer-close]", layer).forEach(function (el) { el.addEventListener("click", close); });
  }

  /* ---------------------------------------------------------- hero film */
  function initHero() {
    var video = $("[data-alme-hero-video]");
    var btn = $("[data-alme-hero-toggle]");
    if (!video) return;
    if (reduced) video.pause();
    function paint() {
      if (!btn) return;
      var paused = video.paused;
      btn.textContent = paused ? "Play film ▶" : "Pause film Ⅱ";
      btn.setAttribute("aria-label", paused ? "Play Mediterranean film" : "Pause Mediterranean film");
    }
    video.addEventListener("play", paint);
    video.addEventListener("pause", paint);
    paint();
    if (btn) btn.addEventListener("click", function () {
      if (video.paused) { var p = video.play(); if (p && p.catch) p.catch(paint); } else { video.pause(); }
    });
  }

  /* ---------------------------------------------------------- rails */
  function initRails() {
    var benefits = $("[data-alme-benefit-rail]");
    if (benefits) {
      var move = function (dir) {
        var first = $("li", benefits);
        var gap = parseFloat(getComputedStyle(benefits).columnGap || "30") || 30;
        var dist = (first ? first.offsetWidth : benefits.clientWidth / 3) + gap;
        benefits.scrollBy({ left: dist * dir, behavior: "smooth" });
      };
      var sec = benefits.closest("[data-alme-benefits]");
      $("[data-alme-rail-prev]", sec).addEventListener("click", function () { move(-1); });
      $("[data-alme-rail-next]", sec).addEventListener("click", function () { move(1); });
    }
    $$("[data-rail]").forEach(function (btn) {
      var rail = document.getElementById(btn.getAttribute("data-rail"));
      var dir = btn.hasAttribute("data-alme-rail-prev") ? -1 : 1;
      btn.addEventListener("click", function () {
        if (rail) rail.scrollBy({ left: dir * rail.clientWidth * 0.82, behavior: "smooth" });
      });
    });
  }

  /* ---------------------------------------------------------- circadian split slider */
  function initSplit() {
    $$("[data-alme-split]").forEach(function (box) {
      var input = $("input[type=range]", box);
      if (!input) return;
      input.addEventListener("input", function () { box.style.setProperty("--split", input.value + "%"); });
    });
  }

  /* ---------------------------------------------------------- UGC strip */
  function initUgc() {
    $$("[data-alme-ugc]").forEach(function (section) {
      var rail = $("[data-alme-ugc-rail]", section);
      var dots = $$("[data-alme-ugc-dots] button", section);
      var dotWrap = $("[data-alme-ugc-dots]", section);
      if (!rail) return;
      var videos = $$("video", rail);
      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting && !reduced) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
            else v.pause();
          });
        }, { threshold: 0.55 });
        videos.forEach(function (v) { io.observe(v); });
      }
      function step() {
        var card = $("article", rail);
        if (!card) return 1;
        return card.offsetWidth + (parseFloat(getComputedStyle(rail).columnGap || "20") || 20);
      }
      function paint(active) {
        dots.forEach(function (d, i) {
          d.className = i === active ? "UgcStrip_dotActive" : "UgcStrip_dot";
          d.setAttribute("aria-selected", i === active ? "true" : "false");
        });
      }
      rail.addEventListener("scroll", function () {
        var i = Math.round(rail.scrollLeft / step());
        paint(Math.min(videos.length - 1, Math.max(0, i)));
      }, { passive: true });
      dots.forEach(function (d, i) {
        d.addEventListener("click", function () { rail.scrollTo({ left: i * step(), behavior: "smooth" }); });
      });
      function measure() { if (dotWrap) dotWrap.hidden = !(rail.scrollWidth > rail.clientWidth + 8); }
      measure();
      window.addEventListener("resize", measure);
    });
  }

  /* ---------------------------------------------------------- ritual dialog (duo / am / pm / ingredients / guide) */
  function initRitualDialog() {
    var dialog = $("[data-alme-ritual-dialog]");
    if (!dialog) return;
    var tabs = $$(".dialogTabs button", dialog);
    var panels = $$("[data-panel]", dialog);
    var title = $("[data-alme-ingredients-title]", dialog);
    var input = $("[data-alme-ingredient-search]", dialog);
    var rows = $$("[data-alme-ingredient]", dialog);
    var empty = $("[data-alme-ingredient-empty]", dialog);

    function norm(v) { return String(v).toLowerCase().replace(/coenzyme\s*q10/g, "coq10"); }
    function filter() {
      var q = norm(input ? input.value : "");
      var shown = 0;
      rows.forEach(function (row) {
        var hit = norm(row.getAttribute("data-alme-ingredient")).indexOf(q) !== -1;
        row.hidden = !hit;
        if (hit) shown++;
      });
      if (empty) empty.hidden = shown !== 0;
    }
    function setView(view) {
      var panelKey = view === "search" ? "ingredients" : view;
      tabs.forEach(function (t) { t.setAttribute("aria-pressed", t.getAttribute("data-view") === view ? "true" : "false"); });
      panels.forEach(function (p) { p.hidden = p.getAttribute("data-panel") !== panelKey; });
      if (title) title.textContent = view === "search" ? "Find your ingredient." : "Know what goes inside.";
    }
    tabs.forEach(function (t) { t.addEventListener("click", function () { setView(t.getAttribute("data-view")); }); });
    if (input) input.addEventListener("input", filter);

    document.addEventListener("click", function (e) {
      var link = e.target.closest && e.target.closest("a[data-ritual]");
      if (!link) return;
      e.preventDefault();
      if (input) input.value = "";
      filter();
      setView(link.getAttribute("data-ritual") || "duo");
      var drawerClose = $("[data-alme-drawer-layer].HeaderHero_drawerLayerOpen [data-alme-drawer-close]");
      if (drawerClose) drawerClose.click();
      if (!dialog.open) dialog.showModal();
    });
    dialog.addEventListener("click", function (e) { if (e.target === dialog) dialog.close(); });
    $$("[data-alme-ritual-close]", dialog).forEach(function (b) { b.addEventListener("click", function () { dialog.close(); }); });
    setView("duo");
  }

  /* ---------------------------------------------------------- generic accordions */
  function toggleRow(row, trigger, body, open) {
    row.setAttribute("data-open", open ? "true" : "false");
    trigger.setAttribute("aria-expanded", open ? "true" : "false");
    if (body) body.hidden = !open;
  }
  function initAccordions() {
    // shop buy box accordion: several can be open one at a time
    $$(".Shop_accordion").forEach(function (wrap) {
      var rows = $$(".Shop_acc", wrap);
      rows.forEach(function (row) {
        var btn = $("h2 button", row), body = $(".Shop_accBody", row);
        btn.addEventListener("click", function () {
          var willOpen = row.getAttribute("data-open") !== "true";
          rows.forEach(function (r) { toggleRow(r, $("h2 button", r), $(".Shop_accBody", r), false); });
          toggleRow(row, btn, body, willOpen);
        });
      });
    });
    // "The ritual inside": one open row at a time
    $$("[data-alme-accordion=single]").forEach(function (wrap) {
      var rows = $$(".Shop_ritualRow", wrap);
      rows.forEach(function (row) {
        var btn = $("h3 button", row), body = $(".Shop_ritualBody", row);
        btn.addEventListener("click", function () {
          var willOpen = row.getAttribute("data-open") !== "true";
          rows.forEach(function (r) { toggleRow(r, $("h3 button", r), $(".Shop_ritualBody", r), false); });
          toggleRow(row, btn, body, willOpen);
        });
      });
    });
    // science ingredient list
    $$("[data-alme-ingredient-list]").forEach(function (wrap) {
      var list = $("[data-ingredient-scroll]", wrap);
      var more = $("[data-scroll-more]", wrap);
      var rows = $$(".Science_ingredient", wrap);
      rows.forEach(function (row) {
        var btn = $(".Science_ingredientHead", row), body = $(".Science_ingredientBody", row);
        btn.addEventListener("click", function () {
          var willOpen = row.getAttribute("data-open") !== "true";
          rows.forEach(function (r) { toggleRow(r, $(".Science_ingredientHead", r), $(".Science_ingredientBody", r), false); });
          toggleRow(row, btn, body, willOpen);
          update();
        });
      });
      function update() {
        var atEnd = list.scrollTop + list.clientHeight >= list.scrollHeight - 4;
        more.setAttribute("data-end", atEnd ? "true" : "false");
        more.setAttribute("aria-label", atEnd ? "Back to the first ingredient" : "Show more ingredients");
        return atEnd;
      }
      list.addEventListener("scroll", update, { passive: true });
      more.addEventListener("click", function () {
        var atEnd = update();
        list.scrollBy({ top: atEnd ? -list.scrollHeight : 220, behavior: "smooth" });
      });
      update();
    });
    // faq with category pills
    $$("[data-alme-faq]").forEach(function (faq) {
      var tabs = $$(".Shop_faqTabs button", faq);
      var rows = $$(".Shop_faqRow", faq);
      function showTab(name) {
        tabs.forEach(function (t) { t.setAttribute("aria-selected", t.getAttribute("data-tab") === name ? "true" : "false"); });
        rows.forEach(function (r) {
          r.hidden = r.getAttribute("data-category") !== name;
          toggleRow(r, $("h3 button", r), $("div", r), false);
        });
      }
      tabs.forEach(function (t) { t.addEventListener("click", function () { showTab(t.getAttribute("data-tab")); }); });
      rows.forEach(function (row) {
        var btn = $("h3 button", row), body = $("div", row);
        btn.addEventListener("click", function () { toggleRow(row, btn, body, row.getAttribute("data-open") !== "true"); });
      });
    });
    // what's inside one capsule
    $$("[data-alme-inside]").forEach(function (wrap) {
      var slides = $$("[data-slide]", wrap);
      var dots = $$("[data-dot]", wrap);
      var index = 0;
      function show(i) {
        index = i;
        slides.forEach(function (s, n) { s.hidden = n !== i; });
        dots.forEach(function (d, n) { d.setAttribute("aria-selected", n === i ? "true" : "false"); });
      }
      dots.forEach(function (d, n) { d.addEventListener("click", function () { show(n); }); });
      var next = $("[data-inside-next]", wrap);
      if (next) next.addEventListener("click", function () { show((index + 1) % slides.length); });
    });
  }

  /* ---------------------------------------------------------- person dialogs (team + leaders) */
  function initPersonDialogs() {
    $$("[data-alme-person-dialog]").forEach(function (dialog) {
      var section = dialog.parentElement;
      var panels = $$("[data-person-panel]", dialog);
      $$("[data-alme-person]", section).forEach(function (btn) {
        btn.addEventListener("click", function () {
          var i = btn.getAttribute("data-alme-person");
          panels.forEach(function (p) { p.hidden = p.getAttribute("data-person-panel") !== i; });
          dialog.showModal();
        });
      });
      $$("[data-alme-dialog-close]", dialog).forEach(function (b) { b.addEventListener("click", function () { dialog.close(); }); });
      dialog.addEventListener("click", function (e) { if (e.target === dialog) dialog.close(); });
    });
  }

  /* ---------------------------------------------------------- shop buy box */
  function initShop() {
    var root = $("[data-alme-shop]");
    if (!root) return;
    var state = { variant: "duo", image: 0 };
    var panels = $$("[data-variant-panel]", root);
    var switchBtns = $$("[data-variant]", root);
    var note = $("[data-cart-note]", root);
    var sticky = $("[data-sticky-bar]", root);
    var stickyTitle = $("[data-sticky-title]", root);
    var stickyPlan = $("[data-sticky-plan]", root);
    var stickyAdd = $("[data-sticky-add]", root);
    var heroSection = root;

    function selectedPlan() {
      var p = panels.filter(function (el) { return el.getAttribute("data-variant-panel") === state.variant && $(".Shop_plans", el); })[0];
      return p ? $(".Shop_plan.Shop_planOn", p) : null;
    }
    function euro(v) { return "€" + v; }
    function refreshSticky() {
      var plan = selectedPlan();
      var buy = panels.filter(function (el) { return el.getAttribute("data-variant-panel") === state.variant && el.hasAttribute("data-title"); })[0];
      if (!plan || !buy) return;
      var save = Number(plan.getAttribute("data-save"));
      if (stickyTitle) stickyTitle.textContent = buy.getAttribute("data-title");
      if (stickyPlan) stickyPlan.textContent = plan.getAttribute("data-label") + (save ? " · Save " + save + "%" : "");
      if (stickyAdd) stickyAdd.textContent = "Add · " + euro(plan.getAttribute("data-total"));
    }
    function setImage(i) {
      state.image = i;
      panels.forEach(function (p) {
        if (p.getAttribute("data-variant-panel") !== state.variant) return;
        $$("[data-stage-image]", p).forEach(function (el) { el.hidden = Number(el.getAttribute("data-stage-image")) !== i; });
        $$("[data-thumb]", p).forEach(function (t) { t.setAttribute("aria-current", Number(t.getAttribute("data-thumb")) === i ? "true" : "false"); });
      });
    }
    function setVariant(key) {
      state.variant = key;
      panels.forEach(function (p) { p.hidden = p.getAttribute("data-variant-panel") !== key; });
      switchBtns.forEach(function (b) { b.setAttribute("aria-checked", b.getAttribute("data-variant") === key ? "true" : "false"); });
      if (note) note.textContent = note.getAttribute("data-default");
      setImage(0);
      refreshSticky();
    }
    switchBtns.forEach(function (b) { b.addEventListener("click", function () { setVariant(b.getAttribute("data-variant")); }); });

    root.addEventListener("click", function (e) {
      var thumb = e.target.closest("[data-thumb]");
      if (thumb) { setImage(Number(thumb.getAttribute("data-thumb"))); return; }
      var next = e.target.closest("[data-next-image]");
      if (next) {
        var p = panels.filter(function (el) { return el.getAttribute("data-variant-panel") === state.variant && $("[data-stage-image]", el); })[0];
        var count = p ? $$("[data-stage-image]", p).length : 1;
        setImage((state.image + 1) % count);
      }
    });

    // plans
    $$(".Shop_plans", root).forEach(function (group) {
      $$("input[type=radio]", group).forEach(function (input) {
        input.addEventListener("change", function () {
          $$(".Shop_plan", group).forEach(function (l) { l.classList.toggle("Shop_planOn", $("input", l).checked); });
          var plan = $(".Shop_planOn", group);
          var total = $("[data-add-total]", group.parentElement);
          if (total && plan) total.textContent = euro(plan.getAttribute("data-total")) + " →";
          refreshSticky();
        });
      });
    });

    // add to cart
    function addToCart() {
      var plan = selectedPlan();
      var id = plan && plan.getAttribute("data-variant-id");
      if (!id) { if (note) note.textContent = note.getAttribute("data-demo"); return; }
      var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      fetch(root_url + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error("add failed");
        window.location.href = root_url + "cart";
      }).catch(function () {
        if (note) note.textContent = "Sorry, this item could not be added. Please try again.";
      });
    }
    $$("[data-add-to-cart]", root).forEach(function (b) { b.addEventListener("click", addToCart); });

    // sticky bar: shown once the buy box has scrolled above the viewport, hidden again at the footer
    var buyBox = $("[data-alme-buybox]", root);
    var state2 = { past: false, footer: false };
    function paintSticky() {
      var on = state2.past && !state2.footer;
      sticky.classList.toggle("Shop_stickyOn", on);
      sticky.setAttribute("aria-hidden", on ? "false" : "true");
      stickyAdd.tabIndex = on ? 0 : -1;
    }
    if ("IntersectionObserver" in window && buyBox && sticky) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        state2.past = !en.isIntersecting && en.boundingClientRect.top < 0;
        paintSticky();
      }, { threshold: 0 }).observe(buyBox);
      var footer = $("footer");
      if (footer) new IntersectionObserver(function (entries) { state2.footer = entries[0].isIntersecting; paintSticky(); }).observe(footer);
    }

    // /pages/shop#am or #pm pre-selects that product
    function fromHash() {
      var h = window.location.hash.replace("#", "");
      if (h === "am" || h === "pm" || h === "duo") setVariant(h);
    }
    setVariant("duo");
    fromHash();
    window.addEventListener("hashchange", fromHash);
  }

  function boot() {
    initHeader();
    initHero();
    initRails();
    initSplit();
    initUgc();
    initRitualDialog();
    initAccordions();
    initPersonDialogs();
    initShop();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
